import React, {forwardRef, useImperativeHandle, useState} from "react";
import {Button, Flex, Result, Spin, Upload, UploadProps} from "antd";
import {LoadingOutlined, UploadOutlined, CheckCircleOutlined} from "@ant-design/icons";
import {LoadingStatus, StatusProps} from "./types";
import { uploadLeftBook } from "../../../services/api";

interface LeftStatus {
    loadingStatus: LoadingStatus;
    error?: string;
    leftName?: string;
}

export interface LeftUploadHandle {
    uploadExampleFile: (file: File) => Promise<{ project_id: string; left_book_name: string }>;
}

const LeftUpload = forwardRef<LeftUploadHandle, StatusProps>((leftStatusProps: StatusProps, ref) => {
    const [leftStatus, setLeftStatus] = useState<LeftStatus>({
        loadingStatus: LoadingStatus.Init,
    });

    const performUpload = async (file: File) => {
        setLeftStatus({
            loadingStatus: LoadingStatus.Loading,
        });

        try {
            const data = await uploadLeftBook(file);
            setLeftStatus({
                loadingStatus: LoadingStatus.Success,
                leftName: data.left_book_name,
            });
            leftStatusProps.setResult(true, {
                projectID: data.project_id,
                leftName: data.left_book_name,
            }, null);
            return data;
        } catch (error: any) {
            setLeftStatus({
                loadingStatus: LoadingStatus.Fail,
                error: error?.message || 'Upload failed',
            });
            leftStatusProps.setResult(false, null, error);
            throw error;
        }
    };

    const props: UploadProps = {
        name: 'left',
        customRequest: async (componentsData) => {
            try {
                const file = componentsData.file as File;
                await performUpload(file);
                componentsData.onSuccess?.({}, file as any);
            } catch (error) {
                componentsData.onError?.(error as Error);
            }
        },
    };

    useImperativeHandle(ref, () => ({
        uploadExampleFile: (file: File) => performUpload(file),
    }));

    return (
        <>
            {
                leftStatus.loadingStatus === LoadingStatus.Init ?
                    <Flex justify="center" align="center" style={{ height: '100%' }}>
                        <Upload {...props}>
                            <Button icon={<UploadOutlined />}>Select a book that will be left</Button>
                        </Upload>
                    </Flex>: null
            }
            {
                leftStatus.loadingStatus === LoadingStatus.Success ?
                    <Result status="success" title={leftStatus.leftName} icon={<CheckCircleOutlined style={{color: 'rgba(43, 43, 43, 1)'}} />} /> : null
            }
            {
                leftStatus.loadingStatus === LoadingStatus.Loading ?
                    <Spin indicator={<LoadingOutlined spin />} size="large"/> : null
            }
        </>
    )
});

LeftUpload.displayName = 'LeftUpload';

export default LeftUpload;